<template>
  <v-flex>
    <v-form>
      <v-progress-linear
        :indeterminate="true"
        v-if="isLoading"
      ></v-progress-linear>
      <v-select
        :items="sets"
        menu-props="auto"
        item-text="Bezeichnung"
        item-value="ID"
        v-model="stueck.setID"
        label="Prüfungsset"
      />
      <v-text-field
        label="PrfStkNr"
        v-model="stueck.PrfStkNr"
        required
      ></v-text-field>
      <v-select
        :items="standorte"
        menu-props="auto"
        item-text="Standort"
        item-value="StandortID"
        v-model="stueck.standortID"
        label="Prüfungszentrum"
      ></v-select>
      <v-checkbox label="Gesperrt" v-model="stueck.Gesperrt" />
      <div v-if="stueck.ID > 0">
        <v-subheader>Dokumente</v-subheader>
        <v-alert
          type="info"
          :value="!isLoading && (!documents || documents.length === 0)"
          >keine Dokumente vorhanden</v-alert
        >
        <div
          class="item-docs"
          v-if="!isLoading && documents && documents.length"
        >
          <div class="item-docs__doc" v-for="doc in documents" :key="doc.Id">
            <v-icon>description</v-icon>
            <a class="doc__title" :href="getViewerLink(doc)" target="_blank">{{
              getType(doc).Item
            }}</a>
          </div>
        </div>
        <div v-if="showFileUpload">
          <v-subheader>Dokument hochladen</v-subheader>
          <v-select
            :items="fileTypes"
            v-model="selectedFileType"
            label="Art"
          ></v-select>
          <FileUploadComponent @input="fileSelected" />
          <v-btn
            @click="uploadFile"
            :disabled="fileToUpload === null || selectedFileType.length === 0"
            >Datei hochladen</v-btn
          >
        </div>
        <v-btn v-if="!showFileUpload" @click="showFileUpload = !showFileUpload"
          >Dokument hochladen</v-btn
        >
      </div>
      <v-btn color="success" @click="save">Speichern</v-btn>
      <v-btn @click="cancel">Abbrechen</v-btn>
    </v-form>
  </v-flex>
</template>

<script>
import FileUploadComponent from "../FileUploadComponent.vue";
export default {
  name: "EditPruefungsstueckComponent",
  props: ["stueck", "documents", "sets", "standorte", "isLoading"],
  components: {
    FileUploadComponent,
  },
  data() {
    return {
      fileTypes: ["Protokoll 1", "Protokoll 2", "Dokumentation"],
      selectedFileType: "",
      fileToUpload: null,
      showFileUpload: false,
    };
  },
  methods: {
    save() {
      this.$emit("onSave", this.stueck);
    },
    cancel() {
      this.$router.back();
    },
    getType(doc) {
      return doc.Fields.find((f) => f.FieldName === "DOKUMENTENART");
    },
    getThumbnail(doc) {
      var thumburl = doc.Links.find((f) => f.rel === "thumbnail") || {
        href: "",
      };
      return `https://docuware2012.dgzfp.de${thumburl.href}`;
    },
    getViewerLink(doc) {
      return `https://docuware2012.dgzfp.de/DocuWare/Platform/WebClient/SSO/5751abb1-c229-4ee4-a890-664714018eb5/Integration?p=V&fc=${doc.FileCabinetId}&did=${doc.Id}`;
    },
    fileSelected(file) {
      this.fileToUpload = file;
    },
    uploadFile() {
      var fd = new FormData();
      fd.append("type", this.selectedFileType);
      fd.append("file", this.fileToUpload, this.fileToUpload.name);

      this.$emit("onUploadFile", fd);

      this.selectedFileType = "";
      this.fileToUpload = null;
      this.showFileUpload = false;
    },
  },
};
</script>

<style scoped>
.item-docs {
  display: flex;
  margin-bottom: 4rem;
  justify-content: flex-start;
}

.item-docs__doc {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  max-width: 12rem;
}

.doc__thumb {
  align-self: center;
}

.doc__title {
  align-self: center;
}
</style>
